'use client';

import { cn } from '@/lib/utils';

import { useTheme } from '@/providers/theme-provider';

interface ThemeToggleProps {
  /** `chrome`: top navigation (legacy style guide pairing). `surface`: marketing / auth canvases. */
  variant?: 'chrome' | 'surface';
}

/**
 * Mirrors **`documents/vunapay_styleguide.html`**: pill + sliding thumb (`vp-theme`).
 */
export function ThemeToggle({ variant = 'chrome' }: ThemeToggleProps) {
  const { theme, ready, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className={cn(
        'vp-theme-toggle',
        variant === 'surface' && 'vp-theme-toggle--surface border-border bg-muted/80 hover:border-brand-gold/60',
        !ready && 'pointer-events-none opacity-80',
      )}
      aria-label={ready ? `Switch to ${isDark ? 'light' : 'dark'} theme` : 'Theme'}
      aria-busy={!ready}
      onClick={toggleTheme}
    >
      <span className={cn('vp-theme-toggle__label', variant === 'surface' && 'vp-theme-toggle__label--surface')}>
        {ready ? (isDark ? 'Dark' : 'Light') : 'Theme'}
      </span>
      <span className="vp-theme-toggle__track" aria-hidden>
        <span className="vp-theme-toggle__thumb">{ready ? (isDark ? '🌙' : '☀️') : '◐'}</span>
      </span>
    </button>
  );
}
